import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getTextAnalysisReports(selectedJournalIds) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.TEXT_ANALYSIS_REPORTS,
    method: "get",
  });
}
